import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingScreen from '../core/LoadingScreen';

const PublicGate = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (user) {
    const isProfileComplete = user.isVerified || (user.name && user.class);
    if (isProfileComplete) {
      // Logged in, profile complete. Redirect to app.
      return <Navigate to="/all-records" replace />;
    } else {
      // Logged in, profile incomplete. Redirect to name-verification.
      return <Navigate to="/name-verification" replace />;
    }
  }

  // Not logged in. Show the public page.
  return children;
};

export default PublicGate;